import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IOrderMSDocument } from '~/types/document/models'

export const {
  getDocumentListData: getOrderMSDocumentListData,
  getDocumentDataById: getOrderMSDocumentDataById,
  getDocumentListDataByParentId: getOrderMSDocumentListDataByMOMSId,
} = makeDocumentMockData<IOrderMSDocument>({
  entityName: 'orderMasterService',
  storageKeyPrefix: 'orderms',
})
